import React from 'react';
import { Link } from 'react-router-dom';
import { RDReadyLogo } from './RDReadyLogo';
export function RDReadyFooter() {
  return <footer className="border-t border-[#EDF1F7] bg-[#F7F9FC] px-5 py-12 text-[#475569] md:px-8" style={{
    fontFamily: '"Poppins", "Inter", system-ui, sans-serif'
  }} data-id="element-3857" data-mp="hfxtjn26cn4a">
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-[1.5fr_1fr_1fr]" data-id="element-3858" data-mp="qej8774izhzs">
        <div data-id="element-3859" data-mp="1535xa0jyfo47">
          <Link to="/" className="inline-flex" aria-label="RD Ready home" data-id="element-3860" data-mp="152nqi9zo1ri1">
            <RDReadyLogo className="h-9 w-40" data-id="element-3861" data-mp="105xafmnv2vwm" />
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#64748B]" data-id="element-3862" data-mp="1e4wzgvfadctb">
            Evidence-based study tools built by dietitians to help you pass the
            RD and CNSC certification exams with confidence.
          </p>
        </div>
        <div data-id="element-3863" data-mp="3fx1nvwxktrza">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#0F172A]" data-id="element-3864" data-mp="3fws6gxqlkt57">
            Explore
          </p>
          <div className="mt-4 flex flex-col gap-2.5 text-sm" data-id="element-3865" data-mp="3bwrfyeq84rhs">
            <Link to="/rd-exam" className="transition-colors hover:text-[#2563EB]" data-id="element-3866" data-mp="2ldf7qq9tj52k">
              RD Exam Prep · $150
            </Link>
            <Link to="/cnsc-exam" className="transition-colors hover:text-[#2563EB]" data-id="element-3867" data-mp="2va0dxexkqm7z">
              CNSC Exam Prep · $150
            </Link>
            <Link to="/study" className="transition-colors hover:text-[#2563EB]" data-id="element-3868" data-mp="350d71vjgfnpq">
              Study Space
            </Link>
            <Link to="/account" className="transition-colors hover:text-[#2563EB]" data-id="element-3869" data-mp="393ro8pj4qa4r">
              Account
            </Link>
          </div>
        </div>
        <div data-id="element-3870" data-mp="3iz33d8yg9jd1">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#0F172A]" data-id="element-3871" data-mp="3ixi9zmnvg6gr">
            Important note
          </p>
          <p className="mt-4 text-sm leading-relaxed text-[#64748B]" data-id="element-3872" data-mp="1olbp1w56ebb9">
            RD Ready is an independent study resource. It is not affiliated
            with, endorsed by, or a guarantee of success on any certification
            examination.
          </p>
        </div>
      </div>
      <div className="mx-auto mt-10 flex max-w-7xl flex-col gap-3 border-t border-[#E2E8F0] pt-6 text-xs text-[#94A3B8] md:flex-row md:justify-between" data-id="element-3873" data-mp="1qj1xxv3g32ri">
        <span data-id="element-3874" data-mp="1linpwd1ufsth">
          © {new Date().getFullYear()} RD Ready. All rights reserved.
        </span>
        <div className="flex gap-5" data-id="element-3875" data-mp="1zigjcg4r8n55">
          <Link to="/privacy" className="transition-colors hover:text-[#2563EB]" data-id="element-3876" data-mp="1vieig96ufxqx">
            Privacy
          </Link>
          <Link to="/terms" className="transition-colors hover:text-[#2563EB]" data-id="element-3877" data-mp="299ba9xsy4awx">
            Terms
          </Link>
        </div>
      </div>
    </footer>;
}